'use strict';

var MapController = require('./MapController');

function MapDirective () {

  function compile () {
    return  {
      pre: function ($scope, $el, attrs, ctrl) {
        $el.css({width: '100%', height: '100%'});
        $el.children().eq(0).css({width: '100%', height: '100%'});
      },
      post: link
    };
  }

  function link ($scope, $el, attrs, ctrl) {
    // jshint unused:false
  }

  return {
    bindToController: true,
    compile: compile,
    controller: MapController,
    controllerAs: 'vm',
    scope: {
      activeLayer: '=?',
      annotations: '=?',
      measurements: '=?',
      annotationsEditable: '=?', // DEPRECATED... use editableTypes instead
      datacaptures: '=?',
      editableTypes: '=?',
      layerEditFn: '&?', // executed with a single param, the `layer` that was edited
      location: '=?',
      mapDefaults: '=?',
      mission: '=?',
      overlays: '=?',
      overlayLayerAuthFn: '&?', // Pass a function to provide extra options to the
                               // overlay layers, such as auth tokens
      photoset: '=?'
    },
    // template: template,
    templateUrl: 'saturn/map/map.tpl.html',
    transclude: true
  };
}

MapDirective.$inject = [];
module.exports = MapDirective;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/MapDirective.js